export default "__VITE_ASSET__DgutUB6F__"